<template>
<v-container fluid>
    <v-row>
        <v-col class="d-flex" cols="12" sm="6">
            <p class="text-h3">Finalizar pedido</p>
        </v-col>
    </v-row>
    <v-row align="center" v-if="(numProductsCart == 0)">
        <v-col cols="12" sm="8" lg="4" md="6">
            <p class="text-center font-italic"> Seu carrinho está vazio.</p>
            <p class="text-center"> 
                <v-btn dark class="text-center" :to="'/store'">
                    Voltar para loja
                </v-btn>
            </p>
        </v-col>
    </v-row>
    
    <v-row v-if="(numProductsCart !== 0)">        
        <v-col cols="5">
            Produtos
            <Product  v-for="product in productsAdded" v-bind:item="product" v-bind:key="product.id" :product="product"></Product>            
        </v-col>        
        <v-col cols="5">            
            <Checkout></Checkout>            
        </v-col>        
    </v-row>
</v-container>
</template>

<script>
import Checkout from "../components/cart/Paypal";
import Product from '../components/cart/CheckoutProduct';

export default {
    components: { Checkout, Product },
    computed:{
        numProductsCart: function(){
            return this.$store.getters.numProductsCart;
        },
        productsAdded(){
            return this.$store.getters.productsAdded;
        }
    }
}
</script>